import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute,Params  } from '@angular/router';
import { FormBuilder, FormGroup, Validators,ReactiveFormsModule } from '@angular/forms';
import {MatSnackBar} from '@angular/material';
import { CommonService } from 'app/_services';


@Component({
  selector: 'app-addedit-language',
  templateUrl: './addedit-language.component.html',
  styleUrls: ['./addedit-language.component.scss']
})
export class AddeditLanguageComponent implements OnInit {
  errorMessage: string;
  languageForm:FormGroup; 
  languageFormSubmitted = false;
  productLoading:Boolean=false
  utoken:string = localStorage.getItem("utoken");
  usermasterid:any = localStorage.getItem("user_master_id");
  languageId:any = "";
  constructor(
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private commonService:CommonService,
    private router: Router,
    private snackbar:MatSnackBar,
  ){
    this.activatedRoute.params.subscribe((params) => {
      if(params.language_id != "" && params.language_id != undefined){
        this.languageId = params.language_id;
        this.getLanguageDetails();
      }
    })
  }

  ngOnInit() {
    this.languageForm = this.formBuilder.group({
      languageName:['',[Validators.required]],
      languageStatus:['Active',[Validators.required]],
      languagecode:['',[Validators.required]]
    }); 
  }

  getLanguageDetails(){
    if(this.languageId != ""){
      this.commonService.getLanguageDetails(this.languageId).subscribe((response)=>{
        if(response.status_code == "200"){
          this.languageForm.controls['languageName'].setValue(response.Data.language_data[0].language_name);
          this.languageForm.controls['languageStatus'].setValue(response.Data.language_data[0].status);
        
          this.languageForm.controls['languagecode'].setValue(response.Data.language_data[0].language_code);
        
        
        }
      })
    }
  }

  OnSubmit(){
    this.languageFormSubmitted = true;
    if(this.languageForm.invalid){
      return;
    }
    this.productLoading=false
    this.commonService.addEditLanguage(this.languageForm,this.languageId).subscribe((response)=>{
   
   
   console.log("response",response)
   
      if(response.status_code == 200){
        this.snackbar.open(response.Metadata.Message, '', {
          duration: 2000,
           verticalPosition:"top",
          extraClasses: ['bg-green']
        });
        this.productLoading=false
        this.router.navigate(['/language-master']);


        /*
        setTimeout(() => {
            this.router.navigate(['/language-master']);
        }, 4000);
*/
        
      }else{

        this.snackbar.open(response.Metadata.Message, '', {
          duration: 2000,
          verticalPosition:"top",
          extraClasses: ['bg-red']
        });
        this.productLoading=false
      //  this.router.navigate(['/language-master']);

      }
    })
  }
}




// WEBPACK FOOTER //
// ./src/app/component/language/addedit-language/addedit-language.component.ts